import { isModeId, type ModeId } from "../config/gameplay-config";

export type GameSceneId = "home" | "gameplay" | "results";

export interface GameFlowSnapshot {
  readonly mode: ModeId | null;
  readonly scene: GameSceneId;
}

export type GameFlowListener = (snapshot: GameFlowSnapshot) => void;

export class GameFlow {
  private readonly listeners = new Set<GameFlowListener>();
  private snapshot: GameFlowSnapshot = { mode: null, scene: "home" };

  public getSnapshot(): GameFlowSnapshot {
    return { ...this.snapshot };
  }

  public showHome(): void {
    this.snapshot = { mode: null, scene: "home" };
    this.notify();
  }

  public startMode(mode: ModeId): void {
    if (!isModeId(mode)) {
      throw new Error(`Unsupported game mode: ${String(mode)}`);
    }
    this.snapshot = { mode, scene: "gameplay" };
    this.notify();
  }

  public showResults(): boolean {
    const mode = this.snapshot.mode;
    if (this.snapshot.scene !== "gameplay" || mode === null) {
      return false;
    }
    this.snapshot = { mode, scene: "results" };
    this.notify();
    return true;
  }

  public subscribe(listener: GameFlowListener): () => void {
    this.listeners.add(listener);
    listener(this.getSnapshot());
    return () => {
      this.listeners.delete(listener);
    };
  }

  private notify(): void {
    for (const listener of this.listeners) {
      listener(this.getSnapshot());
    }
  }
}
